export default {
    goodsPrice: {
        page: {
            PleaseCode: '请输入价格项编码',
            PleaseName: '请输入价格项名称',
            DuplicateName: '平台使用名重复，请重新输入',
            AddPrice: '添加价格项',
            EditPrice: '编辑价格项'
        },
        table: {
            code: '价格项编码',
            item: '通用价格项',
            name: '平台使用名',
        }
    }
};
